import { render, staticRenderFns } from "./canje.vue?vue&type=template&id=620aa32b&scoped=true"
import script from "./canje.vue?vue&type=script&lang=js"
export * from "./canje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620aa32b",
  null
  
)

export default component.exports